/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SupportTicketControllerAddCommentRequestEvidenceUrlsInner } from './supportTicketControllerAddCommentRequestEvidenceUrlsInner';
import { NewSupportTicketReferenceLinksInner } from './newSupportTicketReferenceLinksInner';


/**
 * (tsType: Omit<SupportTicket, \'id\' | \'status\' | \'createdOn\' | \'modifiedOn\' | \'createdBy\' | \'modifiedBy\' | \'deleted\' | \'deletedOn\' | \'deletedBy\'>, schemaOptions: {   title: \'NewSupportTicket\',   exclude: [     \'id\',        \'status\',     \'createdOn\', \'modifiedOn\',     \'createdBy\', \'modifiedBy\',     \'deleted\',   \'deletedOn\',     \'deletedBy\'   ] })
 */
export interface NewSupportTicket { 
    title: string;
    description: string;
    priority?: NewSupportTicket.PriorityEnum;
    moduleId?: string;
    companyId?: string;
    businessUnitId?: string;
    departmentId?: string;
    additionalMetadata?: object;
    evidenceUrls?: Array<SupportTicketControllerAddCommentRequestEvidenceUrlsInner>;
    referenceLinks?: Array<NewSupportTicketReferenceLinksInner>;
    assignedTo?: number | null;
    firstAssignedOn?: string;
    firstResponseOn?: string;
    resolvedOn?: string;
    closedOn?: string;
    responseDueOn?: string;
    resolutionDueOn?: string;
    reopenedCount?: number;
}
export namespace NewSupportTicket {
    export type PriorityEnum = 'low' | 'medium' | 'high' | 'critical';
    export const PriorityEnum = {
        Low: 'low' as PriorityEnum,
        Medium: 'medium' as PriorityEnum,
        High: 'high' as PriorityEnum,
        Critical: 'critical' as PriorityEnum
    };
}


